import { TourLocationDetails } from '../types/tour';

export function stripParentheticals(text: string): string {
  return text.replace(/\s*\([^)]*\)/g, '').replace(/\s+/g, ' ').trim();
}

export function formatTourLocation(details: TourLocationDetails): string {
  return [
    details.placeName,
    details.streetAddress,
    details.city,
    details.state,
    details.country,
  ]
    .filter(Boolean)
    .join(', ');
}

export function parseTourLocation(
  raw: unknown,
  pointOfInterest: string,
  tourCity: string
): { location: string; locationDetails: TourLocationDetails } {
  const cleanPoi = stripParentheticals(pointOfInterest);

  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    const loc = raw as Record<string, unknown>;
    const locationDetails: TourLocationDetails = {
      placeName: stripParentheticals(String(loc.placeName || cleanPoi)),
      streetAddress: stripParentheticals(String(loc.streetAddress || '')),
      city: stripParentheticals(String(loc.city || tourCity)),
      state: stripParentheticals(String(loc.state || '')),
      country: stripParentheticals(String(loc.country || '')),
    };

    return {
      locationDetails,
      location: formatTourLocation(locationDetails),
    };
  }

  const location = stripParentheticals(String(raw ?? ''));
  const locationDetails: TourLocationDetails = {
    placeName: cleanPoi,
    streetAddress: location,
    city: tourCity,
    state: '',
    country: '',
  };

  return { location, locationDetails };
}

export function buildPlacesSearchQuery(
  detail: { pointOfInterest: string; locationDetails?: TourLocationDetails },
  tourCity: string
): string {
  const loc = detail.locationDetails;
  const placeName = loc?.placeName || detail.pointOfInterest;

  return [placeName, loc?.city || tourCity, loc?.state].filter(Boolean).join(', ');
}

export function buildGeocodeQuery(
  detail: { pointOfInterest: string; locationDetails?: TourLocationDetails },
  tourCity: string
): string {
  const loc = detail.locationDetails;
  const placeName = loc?.placeName || detail.pointOfInterest;

  return [
    placeName,
    loc?.streetAddress,
    loc?.city || tourCity,
    loc?.state,
    loc?.country,
  ]
    .filter(Boolean)
    .join(', ');
}
